
import Vue from "vue";
import Component from "vue-class-component";
import PrivacyDialogue from "@/vue/components/PrivacyDialogue.vue";
import Store from "@/store/store";
import Colours from "@/utilities/Colours";
import { BannerOption } from "@/model/Enums";
import { Resource } from "@/model/Resource";

@Component({ components: { PrivacyDialogue }})
export default class VisitorLayout extends Vue {

    async mounted(): Promise<void> {
        // check to see if we need to load settings for colours, etc.
        await this.$store.dispatch("loadClientSettings");
    }

    shouldShowPrivacyDialogue: boolean = false;

    get clientName(): string {
        return this.$store.state.clientSettings?.client?.name ?? "NULL";
    }

    get bannerColour(): string {
        return this.$store.state.clientSettings?.client?.bannerColour ?? "#888";
    }

    get isBannerDark(): boolean {
        console.log(`🌈 isBannerDark - this.bannerColour - type:${typeof this.bannerColour} value:'${this.bannerColour}'`);
        return Colours.isDark(this.bannerColour);
    }

    get logoSource(): string {
        return this.getLogoResource()?.sourceUrl ?? require("@/images/missing.png");
    }

// get siteName(): string {
//     return (store.state.site?.name ?? "MISSING") + " " + this.getLogoResource()?.originalFilename;
// }

    get isLogo(): boolean {
        return Boolean(this.getLogoResource()?.filename);
    }

    get isSolidOption(): boolean {
        return !this.$store.state.clientSettings?.client?.bannerOption
              ||this.$store.state.clientSettings.client.bannerOption === BannerOption.Solid;
    }

    get isRoundedBoxOption(): boolean {
        return this.$store.state.clientSettings?.client?.bannerOption === BannerOption.RoundedBox;
    }

    get isGradientOption(): boolean {
        return this.$store.state.clientSettings?.client?.bannerOption === BannerOption.Gradient;
    }

    get isNoSiteSentinelLogoOption(): boolean {
        return this.$store.state.clientSettings?.client?.bannerOption === BannerOption.NoSiteSentinelLogo;
    }

    getLogoResource(): Resource|null {
        const siteLogo = Store.state.site?.logoResource;
        return siteLogo?.hasFile
            ? siteLogo
            : Store.state.clientSettings?.client?.logoResource;
    }
}
